export default __webpack_public_path__ + "static/media/project-1.7318f337.jpg";